import {create} from 'zustand';

const useFormStore = create((set) => ({
  formData: {
    propertyType: "",
    subPropertyType: "",
    location: "",
    rooms: "",
    constructionYear: "",
    renovationYear: "",
    livingSpace: "",
    plotSize: "",
    floors: "",
    efficiency: "",
    balconySize: "",
    garageSpaces: "",
    parkingSpaces: "",
    condition: "",
    equipment: "",
    reason: "",
    timeline: "",
    basement: "",
    commercialUnits: "",
    commercialArea: "",
    quality: "",
    first_name: "",
    last_name: "",
    street: "",
    city: "",
    country: "",
    email: "",
    home_phone: "",
    accept_contact: false,
    newsletter: false,
    description: "",
    house_number: "",
    zip_code: "",
  },
  step: 1,
  started: false,
  setStarted: (newStarted) => set(() => ({ started: newStarted })),
  updateFormData: (payload) =>
    set((state) => {
      const prev = state.formData;

      // if payload is a function, call it with the old formData
      const newData =
        typeof payload === "function" ? payload(prev) : payload;

      return { formData: { ...prev, ...newData } };
    }),
  setStep: (newStep) => set(() => ({ step: newStep })),
  resetForm: () => {
    set(() => ({ formData: { ...initialState.formData } }));
    setStep(0);
  },
}));

export default useFormStore;
